import { describeResource } from '@siteless/resource';
import { auth } from '../../config/firebase';
import { deserializeCurrentUser } from './services';

export type { CurrentUserResourceType } from './currentUserSchema';

export let CurrentUserResource = describeResource('CurrentUser', {
  get: async () => {
    await auth.authStateReady();
    let user = auth.currentUser;
    let claims = user ? (await user.getIdTokenResult()).claims : undefined;
    return deserializeCurrentUser({ user, claims });
  },
});

export default CurrentUserResource;
